import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {InletDescriptor, OutletDescriptor} from "#template/runtime-graph/descriptors"

const TD = TypeDescriptors

const waitForFinishedModifyingSceneDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    input: TD.inlet(TD.Identity<any>()),
    output: TD.outlet(TD.Identity<any>()),
}

export type WaitForFinishedModifyingSceneDescriptor<T> = {
    sceneManager: InletDescriptor<ISceneManager>
    input: InletDescriptor<T>
    output: OutletDescriptor<T>
}

export class WaitForFinishedModifyingScene<T> implements NodeClassImpl<typeof waitForFinishedModifyingSceneDescriptor, typeof WaitForFinishedModifyingScene> {
    static descriptor = waitForFinishedModifyingSceneDescriptor
    static uniqueName = "WaitForFinishedModifyingScene"
    sceneManager!: Inlet<ISceneManager>
    input!: Inlet<T>
    output!: Outlet<T>

    run() {
        if (this.input === NotReady) return
        if (this.sceneManager === NotReady) return

        const sceneModifyingStatus = this.sceneManager.sceneModifyingStatus()
        if (!sceneModifyingStatus.inProgress) {
            this.output.emitIfChanged(this.input)
            return
        }
        sceneModifyingStatus.onFinished.then(() => this.output.emitIfChanged(this.input))
    }
}
